import { useState } from "react";

import { DEFAULT_SPLASH_LOGO, readSplashBrand } from "@/lib/splash-brand";

/**
 * Écran de chargement plein écran : logo MADA (le « M »), nom de la clinique
 * mémorisé sous le logo (sinon « MADA »).
 *
 * Même dessin que le splash statique d'`index.html` : quand React prend le
 * relais pendant le démarrage (vérification de session, page pas encore
 * chargée), l'utilisateur ne voit aucun saut, la même tuile, le même nom, la
 * même barre.
 */
export function BrandedLoader() {
  const [brand] = useState(readSplashBrand);

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 flex flex-col items-center justify-center gap-5 bg-background"
    >
      <div className="flex h-28 w-28 items-center justify-center border border-border bg-surface">
        <img
          src={DEFAULT_SPLASH_LOGO}
          alt=""
          width={80}
          height={80}
          className="max-h-20 max-w-20 object-contain"
        />
      </div>
      <div className="min-h-4 px-4 text-center text-xs font-semibold uppercase tracking-[0.3em] text-muted">
        {brand.name ?? "MADA"}
      </div>
      <div className="h-[3px] w-28 overflow-hidden bg-border" aria-hidden>
        <span className="block h-full w-2/5 animate-loader-slide bg-primary motion-reduce:w-full motion-reduce:animate-none" />
      </div>
      <span className="sr-only">Chargement…</span>
    </div>
  );
}
